import { object, array, func, element, arrayOf, shape, string, bool, number } from 'prop-types';

export const stringType = string;
export const numberType = number;
export const funcType = func;
export const boolType = bool;
export const arrayType = array;
export const objectType = object;
export const elementType = element;

export const estContactsType = arrayOf(
	shape({
		id: string,
		userId: string,
		firstName: string,
		lastName: string,
		phone: string,
		email: string,
		type: string,
	}),
);

export const phoneType = shape({
	number: string,
	dialCode: string,
	countryCode: string,
	ext: string,
});

export const coordinateType = shape({
	lat: string,
	lng: string,
});

export const addressType = shape({
	address_id: string,
	type: string,
	street: string,
	city: string,
	province: string,
	coountry: string,
	postalCode: string,
	placeId: string,
	coordinate: coordinateType,
	unit: string,
	fullAddress: string,
});

export const imageType = shape({
	file: string,
	name: string,
	preview: string,
});

export const companiesType = arrayOf(
	shape({
		Id: string,
		Name: string,
		RowNumber: string,
	}),
);

export const contactTypesType = arrayOf(
	shape({
		Id: string,
		Title: string,
	}),
);

export const languageType = arrayOf(
	shape({
		id: string,
		code: string,
		name: string,
	}),
);

export const validType = shape({
	isErr: bool,
	errMsg: string,
});

export const roleType = shape({
	Id: string,
	Title: string,
});

export const userType = shape({
	id: string,
	contactId: string,
	firstName: string,
	lastName: string,
	companies: companiesType,
	image: imageType,
	emailWork: string,
	emailPersonal: string,
	emailOther: string,
	contactTypes: contactTypesType,
	phoneWork: phoneType,
	phoneMobile: phoneType,
	phoneOther: phoneType,
	note: string,
	addressWork: addressType,
	addressHome: addressType,
	addressOther: addressType,
	languages: languageType,
	username: string,
	pwd: string,
	confirmPwd: string,
	isEnabled: bool,
	mstCustId: string,
	accessOptions: companiesType,
	roles: roleType,
});
